import { ClassesBuilder } from '@utilities';

const classesConfig = {
  container: 'p-0',
  pagination: 'flex justify-between items-center list-style-none',
  pageItem: 'flex justify-center items-center w-2 h-2 border-1 rounded-sm',
};

export default new ClassesBuilder(classesConfig);
